/*
 * @Author: tager
 * @Date: 2022-04-02 18:40:56
 * @LastEditors: tager
 * @LastEditTime: 2022-04-02 18:57:58
 * @Description: file content
 */
import * as React from 'react';
import * as classNames from 'classnames';
import * as style from './index.css';

export const WKLoading = () => {
  return (
    <div className={style.wkLoading}>
      <div className={style.splashContainer}>
        {/*<img src="https://static-cos.lycheer.net/xupload/20220402_logo.png" alt="" />*/}
        {/*<p className={style.title}>十方教育</p>*/}
        <p className={style.indexTips}>成就技能 助力成长</p>
        <div className={style.skWave}>
          <div className={classNames(style.skRect, style.skRect1)} />
          <div className={classNames(style.skRect, style.skRect2)} />
          <div className={classNames(style.skRect, style.skRect3)} />
          <div className={classNames(style.skRect, style.skRect4)} />
          <div className={classNames(style.skRect, style.skRect5)} />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/WK/WKLoading/index.tsx